// 房间信息(顶部信息条 房间名/过期时间 + 左栏「上次登录」)。
// request.js 已注入前缀 /api/v1/admin + Bearer;拦截器解包 {code,data,msg},.then(data) 拿到即 data。
// 房间上下文由 JWT 决定,无需显式传 room_code。
import request from './request'

// GET /room/info -> { room_code, room_name, expire_at, logo_url, domain,
//                     admin_last_login, preset_draw_enabled, nickname?, avatar?, nickname_len? }
//   expire_at 已由后端格式化为 "YYYY-MM-DD HH:mm:ss" 或 "永久";
//   admin_last_login 为当前登录管理员上次登录时刻("YYYY-MM-DD HH:mm:ss")。
//   dev 房 888888: room_name=测试房 / expire_at=永久 / domain 空 / logo 空(能接多少接多少)。
export function fetchRoomInfo() {
  return request({ url: '/room/info', method: 'get' })
}
